module.exports = __webpack_public_path__ + "assets/img/2.2aefdcd2.jpg";